export const EmployeeInvitation = (json: IEmployeeInvitation): IEmployeeInvitationModel => {
	const fromJSON = (itemJson: IEmployeeInvitation) => {
		const { role, created_at, created_by, expires_at, updated_at, locations, facilities, ...rest } = itemJson
		return {
			role: role ? employeeRoles.find(r => r.value === role) || { value: role, name: role } : null,
			createdAt: created_at ? new Date(created_at) : null,
			createdBy: created_by,
			expiresAt: expires_at ? new Date(expires_at) : null,
			updatedAt: updated_at ? new Date(updated_at) : null,
			locations: locations || [],
			facilities: facilities || [],
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const employeeInvitationToJSON = (obj: Partial<IEmployeeInvitationModel>): Partial<IEmployeeInvitation> => {
	const { role, ...rest } = obj
	return {
		role: role?.value ? role.value : null,
		...rest,
	}
}
